/**
 * «این یکی کارِ کد می‌خواهد» — فرستادنِ یک منبع به صفِ استخراجگر.
 *
 * ⚠️ **این تصمیمِ آدم است، نه حدسِ ابزار.** ستونِ «لازم دارد» از روی
 * اعدادِ آخرین تست حدس می‌زند و حدسش این چند روز سه بار غلط بود. آنچه
 * این‌جا ثبت می‌شود می‌ماند، حتی وقتی تستِ فردا عددِ دیگری بدهد.
 *
 * ⚠️ و **شواهدِ همان لحظه** با آن ثبت می‌شود. شش ماه بعد سوالِ «چرا این
 * این‌جاست؟» پرسیده می‌شود و تستِ آن روز شاید دیگر وجود نداشته باشد —
 * فقط پنج اجرای آخر می‌ماند.
 */
import React, { useState } from 'react';
import {
  TODO_HELP, TODO_LABEL, todoNoteSuggestions, type TodoKind,
} from '@/core/lib/sourcePipeline';
import { Modal } from '@/ui/Modal';

const KINDS: TodoKind[] = ['fix-extractor', 'new-extractor'];

export function TodoDialog({ label, seen, busy, onClose, onSend }: {
  label: string;
  /** یادداشت‌های قبلیِ همین صف — تا هر بار از نو تایپ نشوند. */
  seen: (string | null | undefined)[];
  busy: boolean;
  onClose: () => void;
  onSend: (kind: TodoKind, note: string) => void;
}) {
  /**
   * ⚠️ پیش‌فرض `fix-extractor` است و این یک راهنمایی است، نه تصادف:
   * اصلاحِ `cards` ده‌ها منبع را با هم درست می‌کند، پارسرِ تازه فقط یکی
   * را. کسی که عجله دارد باید به‌صرفه‌ترین گزینه بیفتد.
   */
  const [kind, setKind] = useState<TodoKind>('fix-extractor');
  const [note, setNote] = useState('');
  const options = todoNoteSuggestions(kind, seen);
  const text = note.trim();

  return (
    <Modal title={`کارِ استخراجگر — ${label}`}
      hint="از صفِ منابع بیرون نمی‌رود؛ فقط علامت می‌خورد که کارِ کد لازم دارد."
      onClose={onClose}>
      <div className="chiprow" style={{ marginBottom: 8 }}>
        {KINDS.map((k) => (
          <button key={k} type="button" title={TODO_HELP[k]}
            className={k === kind ? 'chip on' : 'chip'}
            onClick={() => { setKind(k); setNote(''); }}>
            {TODO_LABEL[k]}
          </button>
        ))}
      </div>

      <p className="dim" style={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>
        {TODO_HELP[kind]}
      </p>

      <input className="input" list="todo-notes" value={note}
        placeholder="یادداشت — تایپ کن یا از فهرست بردار"
        onChange={(e) => setNote(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && text) onSend(kind, text); }} />
      <datalist id="todo-notes">
        {options.map((o) => <option key={o} value={o} />)}
      </datalist>

      {/* همان دلیلِ `RejectDialog`: منوی بازشو تا کسی تایپ نکند باز نمی‌شود
          و بارِ اول آدم نمی‌داند فهرستی هم هست. */}
      <div className="chiprow" style={{ marginBottom: 8 }}>
        {options.slice(0, 6).map((o) => (
          <button key={o} type="button" className={o === text ? 'chip on' : 'chip'}
            onClick={() => setNote(o)}>{o}</button>
        ))}
      </div>

      <button className="btn block" type="button" disabled={!text || busy}
        onClick={() => onSend(kind, text)}>
        {busy ? '…' : 'بفرست'}
      </button>
    </Modal>
  );
}
